import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/observable/throw';
//import 'rxjs/add/operator/catch';
import { QueovalBase } from '../shared';
import { StoreService, AlertService } from '../core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { tap, catchError } from 'rxjs/operators';
import { Alert, AlertCode, ToastService } from '../../../../lib-components/src/public_api';

@Injectable()

export class UniversalInterceptor implements HttpInterceptor {

  //////private perfItem: PerfData | null;
  private perfData: PerfData[] = [];


  constructor(
    private store: StoreService,
    private alert: AlertService,
    private toast: ToastService,
    private router: Router
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    console.error(`%c URL: ${request.url}`, 'color: #3933FF; font-size: .9rem; font-weight: bold; font-family: Arial;');
    this.initLogPerf(request.url);

    // cfr the WebStore.API webkey.config file
    const _Tor: string = 'Access-Control-Allow-Origin';
    const _Tmt: string = 'Access-Control-Allow-Methods';
    const _Thd: string = 'Access-Control-Allow-Headers';
    const _aor: string = 'http://localhost,http://localhost:4200,http://192.168.81.36,https://www.queoval.fr,https://applimetier.com';
    const _amt: string = 'GET, POST, OPTIONS';
    const _ahd: string = 'Content-Type, Authorization, Origin, Accept, X-Requested-With, Access-Control-Request-Method, Access-Control-Request-Header';
    const conf: string = 'conf.library.json';
    const auth: string = 'api/loginapp';
    const upld: string = 'api/extraUpload';
    const rUrl: string = request.url;
    const rt: string = (rUrl.indexOf(conf) > -1 || rUrl.indexOf(auth) > -1 || rUrl.indexOf(upld) > -1) ? 'HEADERLESS' : 'BASE';

    switch (rt) {
      case 'HEADERLESS':
        return next.handle(request.clone({ headers: request.headers.append(_Tor, _aor).append(_Tmt, _amt).append(_Thd, _ahd) })).pipe(
          tap((ev: HttpEvent<any>): void => {
            if (ev instanceof HttpResponse) {
              //const rsp: HttpResponse<any> = ev;
              this.logPerf(ev.url ? ev.url : '', new Date());
            }
          }),
          catchError((error: any, caught: any): Observable<never> => {
            this.LogError(error);
            return observableThrowError(error);
          })) as any;
      case 'BASE':
      default:

        return next.handle(request.clone({
          headers: request.headers.append(_Tor, _aor).append(_Tmt, _amt).append(_Thd, _ahd)
            .append('Accept-Language', this.store.AppParams.culture)
            .append('Content-Type', 'application/json')
            .append('Queoval', this.store.AppParams.token)
        })).pipe(
          tap((ev: HttpEvent<any>): void => {
            if (ev instanceof HttpResponse) {
              //const rsp: HttpResponse<any> = ev;
              this.logPerf(ev.url ? ev.url : '', new Date());
              this.showError(ev.body as QueovalBase);
            }
          }),
          catchError((error: any, caught: any): Observable<never> => {
            if (this.store.isBrowserMS()) {
              console.error('INTERCEPTED ERROR');
              if (!error)
                console.error('The error object is undefined');
              else {
                console.error('Error details: ');
                console.error(error.url);
                console.error(error.error);
              }
            }
            else {
              console.error('%c INTERCEPTED ERROR', 'color: #FF0000; font-size: 1.2rem; font-weight: bold; font-family: Arial;');
              if (!error)
                console.error('%c The error object is undefined', 'color: #668cff; font-size: 1rem; font-weight: bold; font-family: Arial;');
              else {
                console.error(`%c Error details`, 'color: #4d4d4d; font-size: 1rem; font-weight: bold; font-family: Arial;');
                console.error(error.url);
                console.error(error.error);
                //try {
                //  if (error.url.indexOf('api/download') > -1) {
                //    const er: string = new TextDecoder('utf-8').decode(new Uint8Array(error.error));
                //    //console.error(`%c Error message: ${er}`, 'color: #FF0000; font-size: 1rem; font-family: Arial;');
                //    this.alert.showAlertToast(er);
                //  }
                //}
                //catch (tryerr) {
                //  console.error('%c error management problem:', 'color: #FF0000; font-size: 1rem; font-family: Arial;');
                //  console.error(`%c ${tryerr.message}`, 'color: #FF0000; font-size: 1rem; font-family: Arial;');
                //}
              }
            }
            this.store.stockData('ERX', JSON.stringify(error));
            this.router.navigate(['view/error']);

            return observableThrowError(error);
          })) as any;
    }
  }

  private showError(response: QueovalBase): void {

    if (response != null && response.CodedAlerts != null && response.CodedAlerts.length > 0) {

      for (let i: number = 0; i < response.CodedAlerts.length; i++) {
        const alert: Alert = response.CodedAlerts[i];

        if (alert.Message.length > 0) {
          switch (alert.Code) {
            case AlertCode.ALERT:
              this.toast.showWarningToast(alert.Message, alert.Message.length < 100 ? 10000 : alert.Message.length * 100);
              break;
            case AlertCode.BLOCKING_ERROR:
              this.toast.showAlertToast(alert.Message, alert.Message.length < 100 ? 10000 : alert.Message.length * 100);
              break;
            case AlertCode.ERROR:
              this.toast.showAlertToast(alert.Message, alert.Message.length < 100 ? 10000 : alert.Message.length * 100);
              break;
            case AlertCode.INFO:
              this.toast.showInfoToast(alert.Message, alert.Message.length < 30 ? 3000 : alert.Message.length * 100);
              break;
            case AlertCode.SUCCESS:
              this.toast.showSuccessToast(alert.Message, alert.Message.length < 30 ? 3000 : alert.Message.length * 100);
              break;
          }
        }
      }
    }
    else if (response != null && response.HasError) {
      this.alert.showSplash(false);
      this.alert.showAlert(response.Error);
    }
  }

  private LogError(error: any): void {
    console.log('Error Occurred');
    console.log((error) ? JSON.stringify(error) : `undefined error on core.service.ts`);
    this.alert.showSplash(false);
  }

  private initLogPerf(api: string): void {
    const perfItem: PerfData = new PerfData(api, new Date());
    this.perfData.push(perfItem);
  }
  private logPerf(api: string, endTime: Date): void {
    const pi: PerfData[] = this.perfData.filter((e: PerfData): boolean => e.apiUrl === api);
    if (pi && pi.length > 0) {
      //if (this.perfItem.apiUrl != api)
      //  alert('this is not the same url');

      pi[0].endTime = endTime;

      const seconds: number = Math.floor((pi[0].endTime as any - (pi[0].startTime as any)) / 1000);
      const minutes: number = Math.floor(seconds / 60);
      const hours: number = Math.floor(minutes / 60);
      const days: number = Math.floor(hours / 24);

      pi[0].totHours = hours - (days * 24);
      pi[0].totMinutes = minutes - (days * 24 * 60) - (pi[0].totHours * 60);
      pi[0].totSeconds = seconds - (days * 24 * 60 * 60) - (pi[0].totHours * 60 * 60) - (pi[0].totMinutes * 60);

      console.log(`the call ${pi[0].apiUrl} lasted: ${pi[0].totSeconds} seconds`);

      const skw: PerfData[] = _.remove(this.perfData, function (n: PerfData): boolean {
        return n.apiUrl === pi[0].apiUrl;
      });

      console.log(this.perfData.length);
      this.perfData.forEach((e: PerfData): void => { console.log(e.apiUrl); });
    }
  }

}

export class PerfData {
  public apiUrl: string;
  public startTime: Date;
  public endTime: Date;
  public totSeconds: number;
  public totMinutes: number;
  public totHours: number;
  constructor(api: string, start: Date) {
    this.apiUrl = api;
    this.startTime = start;
  }
}

